import styled, { css } from 'styled-components';

import { sizeMapper } from '../../../utils/styles';
import Icon from '../Icon';

export const AccordionToggleIcon = styled(Icon).attrs({ icon: 'arrowDownFill' })`
  width: 30px;
  height: 30px;
  margin-right: 15px;
  color: ${props => props.theme.brandPrimary};
  transform: none;
  transition: transform 0.3s ease-out;
`;

export const AccordionToggleIconSimple = styled(Icon).attrs({ icon: 'arrowDown' })`
  width: 12px;
  height: 12px;
  color: ${props => props.theme.brandPrimary};
  transform: none;
  transition: transform 0.3s ease-out;
`;

export const AccordionTitle = styled.span`
  line-height: 22px;
  font-size: 18px;
`;

export const AccordionHead = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 2%;
  border-top: 1px solid ${props => props.theme.grayLight};
  cursor: pointer;
`;

export const AccordionSection = styled.div<{ isOpen?: boolean }>`
  &:first-child {
    ${AccordionHead} {
      border-top: none;
    }
  }

  &:last-child {
    ${AccordionHead} {
      border-bottom: none;
    }
  }

  ${props =>
    props.isOpen &&
    css`
      ${AccordionToggleIcon} {
        transform: rotate(180deg);
      }

      ${AccordionToggleIconSimple} {
        transform: rotate(180deg);
      }
    `};
`;

export const Accordion = styled.div<{ margin?: string }>`
  margin: ${props => sizeMapper(props.margin, 'no')};
  border: solid ${props => props.theme.grayLight};
  border-width: 1px 0;
`;
